export const arrayWithoutEntry = <T>(index: number, elements: T[]): T[] => {
  const dataCopy = [...elements];

  dataCopy.splice(index, 1);

  return dataCopy;
};
